import BaseService from '@root/core/class/BaseService';
import { billingInquiry } from '@root/state/reducers/Settlement/settlementReducer';
import { RcFile } from 'rc-upload/lib/interface';
class settlementSetvice extends BaseService {
  // get return list
  public getSettlementBillingInquiries = (
    page: number,
    sort?: boolean,
    fromDt?: string,
    toDt?: string,
    filterBy?: string,
    searchBy?: string,
    input?: string
  ) => {
    let inputUse = !!input
      ? input.replaceAll('%', '%25').replaceAll('#', '%23')
      : '';
    let url = `/settlements/billingInquiries?page=${page}&limit=10${
      (!!searchBy && !!inputUse
        ? `&searchBy=${searchBy}&search=${inputUse}`
        : '') +
      (!!filterBy ? `&filterBy=billingStatus:${filterBy}` : '') +
      (!!fromDt ? `&fromDt=${fromDt}` : '') +
      (!!toDt ? `&toDt=${toDt}` : '') +
      (!!sort ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC')
    }`;
    return this.get(url);
  };

  // get amount info
  public getSettlementAmountInfo = () => {
    return this.get('/settlements/amountInfo');
  };

  // download billing inquiry
  public postDownloadExcel = (
    currentPage: number,
    sort?: boolean,
    filterDateFrom?: string,
    filterDateTo?: string,
    filterBy?: string,
    searchBy?: string,
    valueSearch?: string,
    serviceInquiry?: boolean
  ) => {
    let url = serviceInquiry
      ? '/settlements/serviceInquiries/export'
      : '/settlements/billingInquiries/export';

    url =
      (!!searchBy && !!valueSearch) ||
      !!sort ||
      filterBy ||
      !!filterDateFrom ||
      !!filterDateTo
        ? url + '?'
        : url;

    url +=
      (!!searchBy && !!valueSearch
        ? `&searchBy=${searchBy}&search=${valueSearch}`
        : '') +
      (!!filterDateFrom ? `&fromDt=${filterDateFrom}` : '') +
      (!!filterBy ? `&filterBy=billingStatus:${filterBy}` : '') +
      (!!filterDateTo ? `&toDt=${filterDateTo}` : '') +
      (sort ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC');
    let urlUse = url.replace('?&', '?');
    return this.post(urlUse, {}, { responseType: 'blob' });
  };

  public postDownloadExelId = (
    body: Record<string, any>,
    serviceInquiry?: boolean
  ) => {
    return this.post(
      serviceInquiry
        ? '/settlements/serviceInquiries/export'
        : '/settlements/billingInquiries/export',
      body,
      {
        responseType: 'blob'
      }
    );
  };

  // get billing detail
  public getBillingInquiryDetail = (id: string) => {
    return this.get(`/settlements/billingInquiries/${id}`);
  };

  // get settlement customer info
  public getCustomerInfo = (searchInfo?: string) => {
    // let inputUse = !!searchInfo
    //   ? searchInfo.replaceAll('%', '%25').replaceAll('#', '%23')
    //   : '';

    let url = `/settlements/customerInfo?customerName=${
      !!searchInfo ? `${searchInfo}` : ''
    }`;
    let urlUse = url.replace('?&', '?');
    return this.get(urlUse);
  };

  // get inquiry & inbound info

  public getInquiryInboundInfo = (
    id: number,
    startDate: string,
    endDate: string
  ) => {
    return this.get(
      `/settlements/InquiryAndInboundInfo?sellerId=${id}&fromDt=${startDate}&toDt=${endDate}`
    );
  };

  // post upload billing Inquiry File
  public postUploadBillingInquiry = (file: any) => {
    return this.post('/settlements/uploadBillingInquiry', file);
  };

  public postCreateBillingInquiry = (bodyCreateBilling: billingInquiry) => {
    return this.post('/settlements/billingInquiries', bodyCreateBilling);
  };

  // get service inquiry
  public getServiceInquiryList = (
    page: number,
    sort?: boolean,
    fromDt?: string,
    toDt?: string,
    filterBy?: string,
    searchBy?: string,
    input?: string
  ) => {
    let inputUse = !!input
      ? input.replaceAll('%', '%25').replaceAll('#', '%23')
      : '';
    let url = `/settlements/serviceInquiries?page=${page}&limit=10${
      (!!searchBy && !!inputUse
        ? `&searchBy=${searchBy}&search=${inputUse}`
        : '') +
      (!!filterBy ? `&filterBy=serviceStatus:${filterBy}` : '') +
      (!!fromDt ? `&fromDt=${fromDt}` : '') +
      (!!toDt ? `&toDt=${toDt}` : '') +
      (!!sort ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC')
    } `;
    return this.get(url);
  };

  // get service inquiry detail
  public getServiceInquiryDetail = (id: string) => {
    return this.get(`/settlements/serviceInquiries/${id}`);
  };

  //capture order when return link after payment by paypal
  public CaptureOrder = (body: Record<string, any>) =>{
    return this.post('/settlements/captureOrderPayment', body);
  }

}

export default new settlementSetvice('/api/v1/warehouse', true);
